
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ColorPicker } from '@/components/ui/color-picker';
import { FormFieldWrapper } from '@/components/ui/form-field-wrapper';
import { MoneyInput } from '@/components/ui/money-input';
import { BankAccountFormData } from '@/types';
import { formPlaceholders } from '@/data/formPlaceholders';

interface AccountFormFieldsProps {
  formData: BankAccountFormData;
  onChange: (field: keyof BankAccountFormData, value: string | number) => void;
  isEdit?: boolean;
  errors?: Record<string, string>;
  onNameBlur?: () => void;
}

export const AccountFormFields = ({
  formData,
  onChange,
  isEdit = false,
  errors = {},
  onNameBlur
}: AccountFormFieldsProps) => {
  return (
    <div className="space-y-6">
      <FormFieldWrapper 
        label="Nome da Conta" 
        required={true} 
        error={errors.name}
      >
        <Input
          id="name"
          placeholder={formPlaceholders.name}
          value={formData.name}
          onChange={(e) => onChange('name', e.target.value)}
          onBlur={onNameBlur}
          className="rounded-xl"
          required
        />
      </FormFieldWrapper>

      <FormFieldWrapper 
        label="Banco" 
        required={true} 
        error={errors.bank}
      >
        <Input
          id="bank"
          placeholder={formPlaceholders.bank}
          value={formData.bank}
          onChange={(e) => onChange('bank', e.target.value)}
          className="rounded-xl"
          required
        />
      </FormFieldWrapper>

      <FormFieldWrapper label="Tipo da Conta" required={false}>
        <Select 
          value={formData.accountType} 
          onValueChange={(value) => onChange('accountType', value)}
        >
          <SelectTrigger className="rounded-xl">
            <SelectValue placeholder={formPlaceholders.type} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="corrente">Conta Corrente</SelectItem>
            <SelectItem value="poupanca">Conta Poupança</SelectItem>
            <SelectItem value="investimento">Conta Investimento</SelectItem>
          </SelectContent>
        </Select>
      </FormFieldWrapper>

      {!isEdit && (
        <FormFieldWrapper label="Saldo Inicial" required={false}>
          <MoneyInput
            id="balance"
            placeholder={formPlaceholders.initialBalance}
            value={formData.balance.toString()}
            onChange={(value) => onChange('balance', parseFloat(value) || 0)}
          />
        </FormFieldWrapper>
      )}

      <FormFieldWrapper label="Número da Conta (Opcional)" required={false}>
        <Input
          id="accountNumber"
          placeholder={formPlaceholders.accountNumber}
          value={formData.accountNumber}
          onChange={(e) => onChange('accountNumber', e.target.value)}
          className="rounded-xl"
          maxLength={12}
        />
        <p className="text-xs text-muted-foreground mt-1">Campo opcional para identificação</p>
      </FormFieldWrapper>

      <ColorPicker
        value={formData.color}
        onChange={(color) => onChange('color', color)}
        label="Cor da Conta"
      />
    </div>
  );
};
